/**
 * Global configuration constants shared across all apps
 */

/**
 * Table configuration
 */
export const TABLE_CONFIG = {
  /**
   * Default number of rows to display per page in tables
   */
  DEFAULT_PAGE_SIZE: 15,
  
  /**
   * Maximum number of rows allowed per page
   */
  MAX_PAGE_SIZE: 100,
  
  /**
   * Minimum number of rows allowed per page
   */
  MIN_PAGE_SIZE: 1,
} as const;
